export default __webpack_public_path__ + "locales/it/EmptyTrashDialog.json?hash=8265e3b59107010cbc89bbb04988aa06";